import { render } from "./DesktopHomePage.vue?vue&type=template&id=1f83b83e&scoped=true"
import script from "./DesktopHomePage.vue?vue&type=script&lang=js"
export * from "./DesktopHomePage.vue?vue&type=script&lang=js"

import "./DesktopHomePage.vue?vue&type=style&index=0&id=1f83b83e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f83b83e"]])

export default __exports__